import _ from "lodash";
import Report from "report";
import TableReportHelper from "report/helper";
import { gerar as gerarTemplateEtiqueta } from "OkReport/template/TemplateEtiqueta";


export default class EtiquetaInscricaoReport extends Report {
    constructor(obj) {
        super();
        //9x3cm
        this.obj = obj;
    }

    get title() {
        return "Etiqueta";
    }

    get template() {
        return { gerar: gerarTemplateEtiqueta };
    }

    get onlyOpen() {
       
        return true;
    }

    get fileName() {
        
        let nomeEmpresa = _.get(this.obj, "empresa.nomeEmpresaCracha")
        return this.title + " - " + nomeEmpresa;
    }

    async render() {
        console.log('render this.obj', this.obj)
        this.helper = new TableReportHelper(this.obj);
        return [
            await EtiquetaInscricaoReport.renderEtiqueta(this.obj)
        ]
    }

    static renderEtiqueta(etiqueta) {
        const h = new TableReportHelper(etiqueta);
        let nomeEmpresa = _.get(etiqueta, "empresa.nomeEmpresaCracha")
        let nomeParticipante = _.get(etiqueta, "empresa.funcionarios.nomeCracha") || _.get(etiqueta, "empresa.funcionarios.nomeParticipante")
        let nomeRodada = _.get(etiqueta, "rodada.nome")

        nomeParticipante = nomeParticipante.slice(0, 26) + (nomeParticipante.length > 26 ? "..." : "")
        nomeEmpresa = nomeEmpresa.slice(0, 37)
        nomeRodada = nomeRodada.slice(0, 74)

        const content = [
            h.panel(
                [
                    h.row(
                        h.title(nomeParticipante, { fontSize: 14, alignment: 'center' })
                    ),
                    h.row(
                        h.title(nomeEmpresa, { fontSize: 11, alignment: 'center' })
                    ),
                    h.row(
                        h.title(nomeRodada, { fontSize: 11, alignment: 'center' })
                    ),
                ],
                { widths: ["*"] }
            ),
        ];

        return content;
    }

}
